import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CacheControlInterceptor implements HttpInterceptor {
	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.responseType === 'json') {
			request = request.clone({
				setHeaders: {
					'Cache-Control': 'no-cache, must-revalidate'
				}
			});
		}
		return next.handle(request);
	}
}
